import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.857 18.365 15.683 34.54a1.571 1.571 0 1 1-2.223-2.223l16.175-16.174H14.57a1.571 1.571 0 0 1 0-3.143h18.862a1.567 1.567 0 0 1 1.103.457l.007.007c.282.284.457.675.457 1.107V33.43a1.571 1.571 0 0 1-3.143 0V18.365Z",
    fill: "currentColor"
  }));
};

var SvgDiagonalUp = styled(SvgComponent).withConfig({
  displayName: "DiagonalUp__SvgDiagonalUp",
  componentId: "sc-1368o0c-0"
})(["", " ", ""], size, color);
export default SvgDiagonalUp;